<template>
    <div>
        <b-container v-if="!mainLoading">
            <b-row>
                <b-col cols="12" sm="3" v-for="provider in providers" :key="provider.id">
                    <b-card :title="provider.name" class="mb-2" img-top img-alt="Provider logo">
                        <div v-if="getSmtpSettings(provider.name)">
                            <p><strong>Hostname:</strong> {{ getSmtpSettings(provider.name).hostName }}</p>
                            <p><strong>Port:</strong> {{ getSmtpSettings(provider.name).portNumber }}</p>
                            <p><strong>Username:</strong> {{ getSmtpSettings(provider.name).username }}</p>
                            <p><strong>Sender Email:</strong> {{ getSmtpSettings(provider.name).senderEmail }}</p>
                            <p><strong>SSL:</strong> {{ getSmtpSettings(provider.name).enableSSL ? 'Yes' : 'No' }}</p>
                            <div class="d-flex justify-content-between">
                                <b-button @click="showEditSmtpModal(getSmtpSettings(provider.name))"
                                    variant="secondary">Edit</b-button>
                                <b-button @click="deleteSmtp(getSmtpSettings(provider.name).id)"
                                    variant="danger">Delete</b-button>
                            </div>
                        </div>
                        <b-button v-else @click="showAddSmtpModal(provider.name)" variant="primary">Add SMTP</b-button>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
        <div class="d-flex justify-content-center" v-if="mainLoading">
            <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem"></b-spinner>
        </div>
        <!-- SMTP Modal -->
        <b-modal id="smtp-modal" ref="smtpModal" :title="`Add SMTP Configuration for ${selectedProvider}`"
            @ok="testSmtpConnection" hide-footer>
            <validation-observer ref="AddForm">
                <b-form @submit.prevent="submitSmtpForm">

                    <b-form-group label="SMTP Server Address:" label-for="smtp-server">
                        <validation-provider #default="{ errors }" name="SMTP Server Address" vid="SMTP Server Address"
                            rules="required">
                            <b-form-input id="smtp-server" v-model="smtpConfig.hostName" required
                                placeholder="Enter SMTP server address"></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>

                    <b-form-group label="Port:" label-for="smtp-port">
                        <validation-provider #default="{ errors }" name="Port" vid="Port" rules="required">
                            <b-form-input id="smtp-port" v-model="smtpConfig.portNumber" required type="number"
                                placeholder="Enter SMTP port"></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group label="Username:" label-for="smtp-username">
                        <validation-provider #default="{ errors }" name="Username" vid="Username" rules="required">
                            <b-form-input id="smtp-username" v-model="smtpConfig.username" required
                                placeholder="Enter SMTP username"></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group label="Password:" label-for="smtp-password">
                        <validation-provider #default="{ errors }" name="Password" vid="Password" rules="required">
                            <b-form-input id="smtp-password" v-model="smtpConfig.password" required type="password"
                                placeholder="Enter SMTP password"></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group label="API Key:" label-for="smtp-apiKey">
                        <validation-provider #default="{ errors }" name="apiKey" rules="required">
                            <b-form-input id="smtp-apiKey" v-model="smtpConfig.apiKey" required type="text" placeholder="Enter SMTP API Key"></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group label="Sender:" label-for="smtp-Sender">
                        <validation-provider #default="{ errors }" name="Sender Email" vid="Sender Email"
                            rules="required">
                            <b-form-input id="smtp-Sender" v-model="smtpConfig.senderEmail" required
                                placeholder="Enter Sender Email"></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group label="Recipient:" label-for="smtp-recipient">
                        <validation-provider #default="{ errors }" name="Recipient Email" vid="Recipient Email"
                            rules="required|email">
                            <b-form-input id="smtp-recipient" v-model="smtpConfig.recipient" required
                                placeholder="Enter Recipient Email"></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-checkbox v-model="smtpConfig.enableSSL" class="my-2">
                        Use Encryption
                    </b-form-checkbox>
                    <b-button type="button" variant="success" @click="testSmtpConnection">Test Connection</b-button>
                </b-form>
            </validation-observer>
        </b-modal>

        <b-modal id="smtp-edit-modal" ref="Edit" :title="`Edit SMTP Configuration for ${smtpConfigEdit.provider}`"
            @ok="testSmtpConnectionEdit" hide-footer>
            <validation-observer ref="EditForm">
                <b-form @submit.prevent="submitSmtpForm">

                    <b-form-group label="SMTP Server Address:" label-for="smtp-server">
                        <validation-provider #default="{ errors }" name="SMTP Server Address" vid="SMTP Server Address"
                            rules="required">
                            <b-form-input id="smtp-server" v-model="smtpConfigEdit.hostName" required
                                placeholder="Enter SMTP server address"></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>

                    <b-form-group label="Port:" label-for="smtp-port">
                        <validation-provider #default="{ errors }" name="Port" vid="Port" rules="required">
                            <b-form-input id="smtp-port" v-model="smtpConfigEdit.portNumber" required type="number"
                                placeholder="Enter SMTP port"></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group label="Username:" label-for="smtp-username">
                        <validation-provider #default="{ errors }" name="Username" vid="Username" rules="required">
                            <b-form-input id="smtp-username" v-model="smtpConfigEdit.username" required
                                placeholder="Enter SMTP username"></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group label="Password:" label-for="smtp-password">
                        <validation-provider #default="{ errors }" name="Password" vid="Password" rules="required">
                            <b-form-input id="smtp-password" v-model="smtpConfigEdit.password" required type="password"
                                placeholder="Enter SMTP password"></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group label="API Key:" label-for="smtp-apiKey">
                        <validation-provider #default="{ errors }" name="apiKey" rules="required">
                            <b-form-input id="smtp-apiKey" v-model="smtpConfigEdit.apiKey" required type="text" placeholder="Enter SMTP API Key"></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group label="Sender:" label-for="smtp-Sender">
                        <validation-provider #default="{ errors }" name="Sender Email" vid="Sender Email"
                            rules="required">
                            <b-form-input id="smtp-Sender" v-model="smtpConfigEdit.senderEmail" required
                                placeholder="Enter Sender Email"></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group label="Recipient:" label-for="smtp-recipient">
                        <validation-provider #default="{ errors }" name="Recipient Email" vid="Recipient Email"
                            rules="required|email">
                            <b-form-input id="smtp-recipient" v-model="smtpConfigEdit.recipient" required
                                placeholder="Enter Recipient Email"></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-checkbox v-model="smtpConfigEdit.enableSSL" class="my-2">
                        Use Encryption
                    </b-form-checkbox>
                    <b-button type="button" variant="success" @click="testSmtpConnectionEdit">Test Connection</b-button>
                </b-form>
            </validation-observer>
        </b-modal>
    </div>
</template>


<script>
import { BContainer, BCard, BCol, BRow, BButton, BModal, BFormGroup, BFormInput, BFormCheckbox, BForm, BSpinner } from 'bootstrap-vue';
import { getProviderName, createProvider, deleteProvider, getProviders, testsmtp, updateProvider } from '@/store/smtp/services';
import { ValidationProvider, ValidationObserver } from "vee-validate";


export default {
    components: {
        BContainer, BCard, BCol, BRow, BButton, BModal, BFormGroup, BFormInput, BFormCheckbox, BForm, BSpinner, ValidationProvider, ValidationObserver,
    },
    data() {
        return {
            providers: [
                { id: 1, name: 'SENDGRID', logo: 'https://simpauldesign.com/wp-content/uploads/2020/02/SendGrid-new-logo.png' },
                { id: 2, name: 'MAILCHIMP', logo: 'https://1000logos.net/wp-content/uploads/2023/04/Mailchimp-logo.png' },
                { id: 3, name: 'BREVO', logo: 'https://corp-backend.brevo.com/wp-content/uploads/2023/04/Dark-logo-cover.jpg' },
                { id: 4, name: 'OTHER', logo: 'https://captainverify.com/fr/blog/wp-content/uploads/2023/12/smtp-jpg.webp' }
            ],
            smtp: [],
            mainLoading: false,
            smtpConfig: {
                provider: '',
                hostName: '',
                portNumber: '',
                username: '',
                senderEmail: '',
                password: '',
                enableSSL: false,
                recipient: '',
                apiKey: null
            },

            smtpConfigEdit: {
                id: '',
                provider: '',
                hostName: '',
                portNumber: '',
                username: '',
                senderEmail: '',
                password: '',
                enableSSL: false,
                recipient: '',
                apiKey: null
            },
            selectedProvider: ''
        };
    },
    methods: {

        showEditSmtpModal(provider) {

            if (provider) {
                this.smtpConfigEdit = {
                    id: provider.id,
                    provider: provider.provider,
                    hostName: provider.hostName,
                    portNumber: provider.portNumber,
                    username: provider.username,
                    senderEmail: provider.senderEmail,
                    password: provider.password,
                    enableSSL: provider.enableSSL,
                    recipient: provider.recipient || '',
                    apiKey: provider.apiKey
                };
                this.selectedProvider = provider.name;
                this.modalTitle = 'Edit SMTP Configuration';
                this.actionButtonLabel = 'Save Changes';
                this.editing = true;
                this.$refs.Edit.show();
            } else {
                console.error("No SMTP settings found for provider:", provider.name);

            }
        },

        async showAddSmtpModal(providerName) {
            let payload = {
                provider: providerName
            };

            this.$swal({
                title: 'Loading...',
                text: 'Please wait while the provider details are being fetched...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            });

            try {
                const response = await getProviderName(payload);
                console.log(response.data.result);
                this.smtpConfig.provider = response.data.result.provider;
                this.smtpConfig.hostName = response.data.result.hostName;
                this.selectedProvider = providerName;
                this.$refs.smtpModal.show();
            } catch (error) {
                console.log(error);
                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Failed to fetch provider details. Please try again.'
                });
            } finally {
                this.$swal.close();
            }
        },

        submitSmtpForm() {
            console.log('Submitting form for:', this.selectedProvider);
            this.testSmtpConnection();
        },

        getSmtpSettings(providerName) {
            return this.smtp.find(setting => setting.provider === providerName);
        },

        async testSmtpConnection() {

            console.log(`Testing SMTP connection for ${this.selectedProvider}...`);
            let payload = { ...this.smtpConfig };
            const isValid = await this.$refs.AddForm.validate();
            if (isValid) {

                this.$swal({
                title: 'Testing Connection...',
                text: 'Please wait while the SMTP connection is being tested...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            });

            try {
                const response = await testsmtp(payload);
                this.$swal.close();

                if (response.data && response.data.success) {
                    this.$swal.fire({
                        title: 'Success!',
                        text: 'SMTP connection successfully tested. Do you want to save these settings?',
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, save it!',
                        cancelButtonText: 'No',
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-danger ml-1",
                        },
                        buttonsStyling: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.saveSmtpSettings();
                        }
                    });
                } else {
                    throw new Error(response.data.message || 'Unknown error');
                }
            } catch (error) {
                console.error('SMTP test failed:', error);
                this.$swal.fire({
                    icon: 'error',
                    title: 'Failed!',
                    text: `SMTP test failed: ${error.response.data.message}. Please check the details and try again.`
                });
            }
            }

         
        },

        async testSmtpConnectionEdit() {
            console.log(`Testing SMTP connection for ${this.selectedProvider}...`);
            let payload = { ...this.smtpConfigEdit };

            const isValid = await this.$refs.EditForm.validate();

            if (isValid){
                this.$swal({
                title: 'Testing Connection...',
                text: 'Please wait while the SMTP connection is being tested...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            });

            try {
                const response = await testsmtp(payload);
                this.$swal.close();

                if (response.data && response.data.success) {
                    this.$swal.fire({
                        title: 'Success!',
                        text: 'SMTP connection successfully tested. Do you want to updated these settings?',
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, update it!',
                        cancelButtonText: 'No',
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-danger ml-1",
                        },
                        buttonsStyling: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.updateSmtpSettings();
                        }
                    });
                } else {
                    throw new Error(response.data.message || 'Unknown error');
                }
            } catch (error) {
                console.error('SMTP test failed:', error);
                this.$swal.fire({
                    icon: 'error',
                    title: 'Failed!',
                    text: `SMTP test failed: ${error.response.data.message}. Please check the details and try again.`
                });
            }
            }
        },
        deleteSmtp(smtpId) {
            this.$swal({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false,
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$swal({
                        title: 'Deleting...',
                        text: 'Please wait while the SMTP settings are being deleted...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });

                    // Assume deleteProvider is an async function that deletes the SMTP settings by ID
                    deleteProvider(smtpId).then(response => {
                        this.$swal.hideLoading();
                        console.log('Delete response:', response);
                        if (response && (response.status === 200)) {
                            this.$swal.fire(
                                'Deleted!',
                                'Your SMTP settings have been deleted.',
                                'success'
                            );
                            // Refresh the SMTP settings list or remove the deleted settings from the local state
                            this.getSMPT();
                        } else {
                            throw new Error('Failed to delete settings.');
                        }
                    }).catch(error => {
                        this.$swal.fire(
                            'Failed to Delete!',
                            error.message || 'There was a problem deleting the SMTP settings.',
                            'error'
                        );

                    });
                }
            });
        },

        async updateSmtpSettings() {
            const isValid = await this.$refs.EditForm.validate();
            if (isValid) {
                this.$swal({
                    title: 'Saving Settings...',
                    text: 'Please wait while the SMTP settings are being updated...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });

                try {
                    const response = await updateProvider(this.smtpConfigEdit);
                    this.$swal.close();

                    if (response.data && response.data.success) {
                        this.$swal.fire({
                            icon: 'success',
                            title: 'Saved!',
                            text: 'SMTP settings have been successfully updated.'
                        });
                        await this.getSMPT();
                        this.$refs.Edit.hide();
                    } else {
                        throw new Error(response.data.message || 'Failed to save settings.');
                    }
                } catch (error) {
                    console.error('Save settings failed:', error);
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Failed to Save!',
                        text: `${error.message}. Please try again.`
                    });
                    await this.getSMPT();
                }

            }

        },

        async saveSmtpSettings() {
            const isValid = await this.$refs.AddForm.validate();

            if (isValid) {
                this.$swal({
                title: 'Saving Settings...',
                text: 'Please wait while the SMTP settings are being saved...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            });

            try {
                const response = await createProvider(this.smtpConfig);
                this.$swal.close();

                if (response.data && response.data.success) {
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Saved!',
                        text: 'SMTP settings have been successfully saved.'
                    });
                    await this.getSMPT();
                    this.$refs.smtpModal.hide();
                } else {
                    throw new Error(response.data.message || 'Failed to save settings.');
                }
            } catch (error) {
                console.error('Save settings failed:', error);
                this.$swal.fire({
                    icon: 'error',
                    title: 'Failed to Save!',
                    text: `${error.message}. Please try again.`
                });
                await this.getSMPT();


            }
            }
          
        },

        async getSMPT() {
            this.mainLoading = true;
            try {
                const response = await getProviders();
                this.smtp = response.data.result;
            } catch (error) {
                console.log(error);
            }
            finally {
                this.mainLoading = false;
            }
        }
    },

    async mounted() {
        await this.getSMPT();
    }
};
</script>


<style>
/* Add any custom styles here */
</style>